import * as Sentry from "@sentry/astro";

Sentry.init({
  dsn: "https://d587f35a54a36be211654aa0a70d0ac4@o791122.ingest.us.sentry.io/4507968919633920",
  debug: false,
  environment: import.meta.env.PUBLIC_VERCEL_ENV,
  release: import.meta.env.PUBLIC_VERCEL_GIT_COMMIT_SHA,
  tracesSampleRate: 1,
  integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1,
});